import axios, {AxiosInstance} from "axios";
import objectToFormData from "../helpers/objectToFormData";

class ApiServiceV2 {
    private instance: AxiosInstance;

    constructor() {
        const wrapper = document.getElementById('zr-customizer-wrapper')
        const url = (wrapper && wrapper.dataset.api)
            ? wrapper.dataset.api :
            '/'

        this.instance = axios.create({
            baseURL: url,
        })
    }

    async callApi(route: string, method = 'get', data: object = {}, files: Blob[] = []) {
        return await this.instance.request({
            method: method,
            url: route,
            data: objectToFormData({...data, ...files}),
            responseType: "json"
        })
    }
}

export default ApiServiceV2;
